//Unleash feature flags
export const CONTRACT_ERROR = 'ContractError';
export const NEW_CONTRACT_HANDLING_FLAG = 'NewContractHandling';
